import { createErrorServiceResponse } from '../../../../helpers/serviceResponseHelper'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { ServiceResponse } from '../../../../model/serviceResponse'
import { replicateAllocationsRequest } from '../../../../pages/allocationsEdit/allocationsEdit.mapper'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { RepartirModelRequest } from '../../model/RepartirModelRequest'
import { RepartirModelResponse } from '../../model/RepartirModelResponse'
import { ReplicateAllocationModel } from '../../model/ReplicateModelRequest'

export class ApiAllocations {
  DistributeAllocationsPOST = async (
    request: RepartirModelRequest[]
  ): Promise<RepartirModelResponse[]> => {
    const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
    return await AxiosInstance.post(`${apiSuffixUrl}/api/Allocations/Distribute`, request)
      .then(response => {
        return response.data
      })
      .catch(error => {
        return createErrorServiceResponse(error)
      })
  }

  DistributeAllocationsAndSavePOST = async (
    nominationQuantity: number,
    request: RepartirModelRequest[]
  ): Promise<RepartirModelResponse[]> => {
    const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
    return await AxiosInstance.post(
      `${apiSuffixUrl}/api/Allocations/DistributeAndSave?cantidad=${nominationQuantity}`,
      request
    )
      .then(response => {
        return response.data
      })
      .catch(error => {
        return createErrorServiceResponse(error)
      })
  }

  ReplicateAllocationDistributionPOST = async (
    allocationsRequest: ReplicateAllocationModel[],
    allocationsModifiedRequest: ReplicateAllocationModel[],
    initDate: Date,
    endDate: Date
  ): Promise<ServiceResponse<any>> => {
    const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
    const request = replicateAllocationsRequest(
      allocationsRequest,
      allocationsModifiedRequest,
      initDate,
      endDate
    )
    return await AxiosInstance.post(
      `${apiSuffixUrl}/api/Allocations/ReplicateAllocationDistribution`,
      request
    ).then(response => {
      return response.data
    })
  }
}
